import * as types from './constants';
import { convertArrayToObject } from '../../utils/arrayConvert';

const initialState = {
  listData: {
    dataTable: [],
    loading: false,
    message: null,
    count: 0,
    next: null,
    previous: null,
    curr_page: 1,
    errors_api: {},
    queryParsed: false
  },
  resendData: {
    data: {},
    loading: false,
    errors_api: false
  },
  deleteData: {
    data: {},
    loading: false,
    errors_api: false
  },
  columnsMemory: {}
};

const actions = {
  // Get Invitations
  [types.GET_INVITATIONS_REQUEST]: state => {
    const data = {
      ...state,
      listData: { ...state.listData, loading: true }
    };

    return { ...data };
  },

  [types.GET_INVITATIONS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        ...payload,
        loading: false
      }
    };

    return { ...data };
  },

  [types.GET_INVITATIONS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      listData: { ...state.listData, loading: false, errors_api: payload }
    };

    return { ...data };
  },

  // Resend Invitation
  [types.RESEND_INVITATION_REQUEST]: state => {
    const data = {
      ...state,
      resendData: { ...state.resendData, loading: true }
    };

    return { ...data };
  },

  [types.RESEND_INVITATION_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      resendData: { ...state.resendData, loading: false, data: payload }
    };

    return { ...data };
  },

  [types.RESEND_INVITATION_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      resendData: { ...state.resendData, loading: false, errors_api: payload }
    };

    return { ...data };
  },

  [types.RESEND_INVITATION_RESET]: state => {
    const data = {
      ...state,
      resendData: initialState.resendData
    };

    return { ...data };
  },

  // Delete Invitation
  [types.DELETE_INVITATION_REQUEST]: state => {
    const data = {
      ...state,
      deleteData: { ...state.deleteData, loading: true }
    };

    return { ...data };
  },

  [types.DELETE_INVITATION_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      deleteData: { ...state.deleteData, loading: false, data: payload }
    };

    return { ...data };
  },

  [types.DELETE_INVITATION_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      deleteData: { ...state.deleteData, loading: false, errors_api: payload }
    };

    return { ...data };
  },

  // Save Columns Width
  [types.SAVE_INVITATIONS_COLUMNS]: (state, { payload }) => {

    const data = {
      ...state,
      columnsMemory: convertArrayToObject(state.columnsMemory, payload)
    };

    return { ...data };
  },

  // Operations
  [types.INVITATIONS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      listData: { ...state.listData, curr_page: parseInt(payload) || 1, queryParsed: true }
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};